// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDone_root__Mk9Zh"};